exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dues-invoice-table td,th{height:24px!important}.row-pointer tbody tr{cursor:pointer}.account-information{text-align:left;margin-bottom:10px}hr{margin-top:5px;margin-bottom:10px;border:0;border-top:1px solid #000}.hidden-filters{display:none}@media print{.pagebreak{page-break-after:always;min-height:1px}body,html{font-size:10pt;margin-top:-50px}#dues_invoice_body{margin:0 12px;font-family:ABCFavorit,serif}}", ""]);

// exports
